module.exports = __webpack_public_path__ + "static/media/Пшеницына Софья Дмитриевна_Марш Черномора_Свердловская обл.-1.png";